import { memo } from 'react'
import SubmitButton from './SubmitButton'

function HistoryButton({ setShowModal, isSubmit, allowToEnter }) {
  return (
    <div className="flex items-center justify-end pb-0">
      <button
        className="w-1/4 text-red-500 background-transparent font-bold uppercase px-6 py-2 text-sm outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
        type="button"
        onClick={() => setShowModal(false)}
      >
        بستن
      </button>
      <SubmitButton allowToEnter={allowToEnter} isSubmit={isSubmit} />
    </div>
  )
}

export default memo(HistoryButton)
